import React from "react"
import Logo from "../images/brandLogos/roundLogo.png"
import SocialMedia from "./SocialMedia"
import { Link } from "gatsby"
import locations from "../data/locations"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-flex">
        <div className="logo">
          <img src={Logo} alt="Sit Lo Saigon Round Logo" />
          <SocialMedia />
        </div>
        <div className="address">
          <h3>Address</h3>
          {locations.map((location, index) => (
            <React.Fragment key={location.name}>
              <section aria-label={`${location.name} location`}>
                <h4>Sit Lo Saigon ({location.name}):</h4>
                <address>
                  <p>{location.addressLine1}</p>
                  <p>{location.addressLine2}</p>
                  <p>
                    <a
                      href={`tel:${location.phoneTel}`}
                      aria-label={`Call ${location.name} location: ${location.phoneDisplay}`}
                    >
                      {location.phoneDisplay}
                    </a>
                  </p>
                </address>
              </section>
              {index < locations.length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
        <div className="hours">
          {locations
            .filter(location => location.hours.length > 0)
            .map((location, index, filtered) => (
              <React.Fragment key={location.name}>
                <section aria-label={`${location.name} hours`}>
                  <h3>Hours ({location.name}):</h3>
                  {location.hours.map(line => (
                    <p key={line}>{line}</p>
                  ))}
                </section>
                {index < filtered.length - 1 && <br />}
              </React.Fragment>
            ))}
        </div>
      </div>
      <hr />
      <p className="bottom-footer">
        &copy; {new Date().getFullYear()}{" "} Sit Lo Saigon, brought to you by the creators of{" "}
        <a href="https://www.saigonalley.com/" target="_blank" rel="noopener noreferrer">
          Saigon Alley Kitchen &amp; Bar
        </a>
      </p>
    </footer>
  )
}

export default Footer
